import { axiosInstance } from ".";

const getJobs = async (params) =>
  await axiosInstance.get("users/user_jobs", {
    params
  });

export { getJobs };
